import {fork, put, takeEvery, all} from 'redux-saga/effects';
import config from '../../../config/config';
import * as types from '../../constants/event/bannerConstants';
import {
    EventsControllerDtoBannerListResponse,
    PerplayEventsApi
} from '../../models/src';
import {getErrorMessage} from '../../../utils/serverErrorCheck';
import BaseResponse from '../../models/src/model/BaseResponse';
import eventsControllerDtoBannerListRequest from "../../models/src/model/EventsControllerDtoBannerListRequest";
import eventsControllerDtoBannerRemoveRequest from "../../models/src/model/EventsControllerDtoBannerRemoveRequest";
import eventsControllerDtoBannerSortUpdateRequest
    from "../../models/src/model/EventsControllerDtoBannerSortUpdateRequest";

const api = new PerplayEventsApi(config.API_CLIENT);

function* bannerCreateRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    console.log(payload);
    try {
        const result = yield api.apiPerplayEventsBannerCreatePost
        (payload && payload.beginDate,
            payload && payload.endDate,
            payload && payload.title,
            payload && payload.deepLink,
            payload && payload,
            () => {
            });

        const data = api.apiClient.deserialize(result, BaseResponse);

        if (data.resultCode !== 200) {
            throw Error(`ERROR: ${data.resultCode}`);
        }
        if (payload.callback) {
            payload.callback();
        }
    } catch (e) {
        payload.error(e);
    }
}

function* bannerUpdateRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const result = yield api.apiPerplayEventsBannerUpdatePost
        (payload && payload,
            () => {
            });

        const data = api.apiClient.deserialize(result, BaseResponse);

        if (data.resultCode !== 200) {
            throw Error(`ERROR: ${data.resultCode}`);
        }
        if (payload.callback) {
            payload.callback();
        }
    } catch (e) {
        payload.error(e);
    }
}

function* bannerListRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new eventsControllerDtoBannerListRequest(
            payload.page,
            payload.pageLength,
            payload.status,
        );
        requestData.searchString = payload.searchString;
        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayEventsBannerListPost({ eventsControllerDtoBannerListRequest: requestData }, () => {});
        const data = api.apiClient.deserialize(result, EventsControllerDtoBannerListResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* bannerDeleteRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new eventsControllerDtoBannerRemoveRequest();
        requestData.bannerNo = payload.bannerNo;
        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayEventsBannerRemovePost({ eventsControllerDtoBannerRemoveRequest: requestData }, () => {});
        const data = api.apiClient.deserialize(result, BaseResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* bannerSortUpdateRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new eventsControllerDtoBannerSortUpdateRequest();
        requestData.sortingIndex = payload.bannerNo;
        console.log('요청 데이터: ', requestData);

        const result = yield api.apiPerplayEventsBannerSortUpdatePost({ eventsControllerDtoBannerSortUpdateRequest: requestData }, () => {});
        const data = api.apiClient.deserialize(result, BaseResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* bannerRootSaga() {
    yield all([
        takeEvery(types.BANNER_CREATE_REQUEST, bannerCreateRequestSaga),
        takeEvery(types.BANNER_UPDATE_REQUEST, bannerUpdateRequestSaga),
        takeEvery(types.BANNER_LIST_REQUEST, bannerListRequestSaga),
        takeEvery(types.BANNER_DELETE_REQUEST, bannerDeleteRequestSaga),
        takeEvery(types.BANNER_SORT_UPDATE_REQUEST, bannerSortUpdateRequestSaga),
    ]);
}

const bannerSagas = [
    fork(bannerRootSaga),
];

export default bannerSagas;
